import {Injectable} from '@angular/core';
import {AuthService} from '../Auth/business/auth.service';
import {UserProfileService} from '../Auth/business/user-profile.service';

@Injectable({
    providedIn: 'root',
})
export class BusinessService {
    constructor(
        public authService: AuthService,
        public userProfileService: UserProfileService
    ) {
    }
}